import { invoke } from '@shared/easyfy.decorators';
import { globalEvent, elements } from '@shared/easyfy.core';
import { visible } from '@shared/easyfy.utils';
import { animationEnded, isMobile } from '@clientShared/utils';

@invoke
export default class Toggle {
  static Instance: Toggle;
  Event: string = 'toggle';

  constructor() {
    Toggle.Instance = this;

    globalEvent({
      type: 'click',
      events: [
        {
          callback: (e) => {
            Toggle.Instance.hideToggle(e?.target);
          },
        },
        {
          event: this.Event,
          callback: this.onToggleElement,
        },
        {
          event: 'toggle-list',
          callback: this.onToggleList,
        },
        {
          event: 'toggle-target-list',
          callback: this.onToggleTargetList,
        },
      ],
    });
  }

  onToggleElement(e: Event, el: HTMLElement, hide: boolean) {
    if (e) {
      if (e?.preventDefault) e.preventDefault();
      if (e.target) el = e.target as HTMLElement;
    }

    let target = el.dataset.target || undefined;

    if (!target) {
      el = el.parentNode as HTMLElement;
      target = el.dataset.target || undefined;
    }

    if (!target) return false;
    const targetList = target.split(';');

    const targetElements: HTMLElement[] = [];

    targetList.forEach((target) => {
      const divs = Array.from(document.querySelectorAll<HTMLElement>(`[data-container="${target}"]`));
      targetElements.push(...divs);
    });

    if (!targetElements) return false;
    const hiddenValue: string = el.attributes['data-hidden-value']?.value;

    targetElements.forEach((item) => {
      if (!item.hasAttribute('toggle-open') && !hide) {
        item.setAttribute('toggle-open', '');
        document.body.classList.add('noof');
      } else {
        item.setAttribute('toggle-closing', '');

        animationEnded(item, () => {
          item.removeAttribute('toggle-closing');
          item.removeAttribute('toggle-open');
          document.body.classList.remove('noof');
        });

        // item.addEventListener('animationend', (e) =>{
        //   item.removeAttribute('toggle-closing');
        //   item.removeAttribute('toggle-open');
        //   document.body.classList.remove('noof');
        // }, {once: true});
      }

      if (hiddenValue) {
        const hiddenInput: HTMLInputElement = item.querySelector('[data-hidden-value]');
        if (hiddenInput) {
          hiddenInput.value = hiddenValue;
        }

        const form: HTMLElement = item.querySelector('[data-action="ajax-form"][data-update]');
        if (form) {
          form.setAttribute('data-update', `${form.attributes['data-update']?.value}-${hiddenValue}`);
        }
      }
    });

    return false;
  }

  hideToggle(target: any) {
    const toggleElements: NodeListOf<HTMLElement> = elements(`[data-event="${Toggle.Instance.Event}"]`);
    const targetsToHide: Map<string, HTMLElement> = new Map();

    toggleElements.forEach((el) => {
      const dataTarget = el.attributes['data-target']?.value;

      const dataTargetElement: NodeListOf<HTMLElement> = document.querySelectorAll<any>(`[data-container="${dataTarget}"]`);
      dataTargetElement.forEach((item) => {
        if (document.contains(target) && !el.contains(target) && visible(item) && visible(el) && !item.contains(target) && el !== target) {
          if (item.hasAttribute('toggle-open')) targetsToHide.set(item.dataset.container, el);
        }
      });
    });

    targetsToHide.forEach((item) => this.onToggleElement(null, item, true));
  }

  onToggleList(e: Event) {
    const el = e.target as HTMLElement;
    const onlyMobile = el.dataset.onlymobile;
    if (onlyMobile && !isMobile()) return;
    const listEl = el?.closest('ul');
    if (listEl) {
      listEl.hasAttribute('list-open') ? listEl.removeAttribute('list-open') : listEl.setAttribute('list-open', '');
    }
  }


  onToggleTargetList(e: Event) {
    const el = e.target as HTMLElement;
    if (el.dataset.onlymobile && !isMobile()) return;

    const targetId = el.getAttribute("data-target");
    if (!targetId) return;

    const listEl = document.querySelector(`[data-container="${targetId}"]`);
    if (!listEl) return;

    [el, listEl].forEach((element) => element.toggleAttribute("list-open"));
  }


}
